import { tv, type VariantProps } from 'tailwind-variants';
export type OrPromotionalBlockVariants = VariantProps<
  typeof orPromotionalBlock
>;

const orPromotionalBlock = tv({
  base: '',
  variants: {
    topSpacing: {
      xs: 'pt-xs',
      sm: 'pt-sm',
      md: 'pt-md',
      lg: 'pt-lg',
      xl: 'pt-xl',
    },
    bottomSpacing: {
      xs: 'pb-xs',
      sm: 'pb-sm',
      md: 'pb-md',
      lg: 'pb-lg',
      xl: 'pb-xl',
    },
  },
  compoundVariants: [],
});

export default orPromotionalBlock;
